import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { AlertService } from '../alert.service';
import { SettingService } from '../setting.service';
import { NgFor, NgIf } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '@main/confirmation-modal/confirmation-modal.component';
import { UpdateTagRequestPayload } from '@app-shared/interfaces/common/tags.model';
import { Tag } from '@app-shared/interfaces/common/tags.model';

@Component({
  selector: 'app-settings-general-clients-tags',
  imports: [NgFor, NgIf, ReactiveFormsModule],
  templateUrl: './settings-general-clients-tags.component.html',
  styleUrl: './settings-general-clients-tags.component.css'
})
export class SettingsGeneralClientsTagsComponent implements OnInit {

  // Properties
  tags = signal<any[]>([]);
  selectedTag = signal<any>(null);

  // View Child For Template Modal
  public modalReference: NgbModalRef;
  public deleteModalReference: NgbModalRef;
  @ViewChild('TAG_MODAL', { static: false }) private tagModal: NgbModalRef;

  // Form
  tagForm: UntypedFormGroup;

  constructor(private settingService: SettingService,
    private modalService: NgbModal,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.tagForm = new UntypedFormGroup({
      tagValue: new UntypedFormControl('', [Validators.required]),
      tagColor: new UntypedFormControl('#000000'),
      tagIsDisplayedOnSchedule: new UntypedFormControl(false)
    });
    this.getTags();
  }

  // Get Tags
  private getTags(): void {
    this.settingService.getTags().subscribe((tags) => {
      this.tags.set(tags);
    });
  }

  // Open Tag Modal
  openTagModal(tag: Tag): void {
    this.selectedTag.set(tag);
    this.tagForm.controls.tagValue.setValue(tag.value);
    this.tagForm.controls.tagColor.setValue(tag.hexColor);
    this.tagForm.controls.tagIsDisplayedOnSchedule.setValue(tag.isDisplayedOnSchedule);
    this.modalReference = this.modalService.open(this.tagModal);
  }

  // Update Tag
  updateTag(): void {
    if (this.tagForm.valid) {
      const payload: UpdateTagRequestPayload = {
        ...this.tagForm.value
      };
      this.settingService.updateTag(this.selectedTag().id, payload).subscribe(() => {
        this.alertService.showSuccessAlert('Tag Updated');
        this.getTags();
        this.modalReference.close();
        this.tagForm.reset();
      });
    } else {
      this.tagForm.markAllAsTouched();
    }
  }

  // Open Delete Tag Confirmation Modal
  openDeleteTagConfirmationModal(): void {
    this.deleteModalReference = this.modalService.open(ConfirmationModalComponent);
    this.deleteModalReference.componentInstance.title = 'Delete Tag';
    this.deleteModalReference.componentInstance.message = `Are you sure you want to delete <b>${this.tagValue.value}</b>?`;
    this.deleteModalReference.componentInstance.actionBtnTitle = 'Continue';
    this.deleteModalReference.componentInstance.actionBtnType = 'DANGER';
    this.deleteModalReference.componentInstance.confirmed.subscribe(() => {
      const tagId = this.selectedTag().id;
      this.settingService.deleteTag(tagId).subscribe(() => {
        this.alertService.showSuccessAlert('Tag Deleted');
        this.getTags();
        this.modalReference?.close();
        this.deleteModalReference?.close();
      });
    });
  }

  get tagValue() { return this.tagForm.get('tagValue'); }
  get tagColor() { return this.tagForm.get('tagColor'); }
  get tagIsDisplayedOnSchedule() { return this.tagForm.get('tagIsDisplayedOnSchedule'); }
}
